import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Check } from 'lucide-react';
import { useI18n } from '../../i18n';
import { SERVICES } from '../../lib/servicesData';

const SERVICE_KEYS = SERVICES;

const ServicesSection = ({ onBookCall }) => {
  const { t } = useI18n();
  return (
    <section id="services" className="py-20 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-orange-600">{t('services.kicker')}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900">{t('services.title')}</h2>
          <p className="mt-4 text-slate-600">{t('services.body')}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICE_KEYS.map((s) => {
            const items = t(`services.items.${s.id}.list`) || [];
            return (
              <div key={s.id} className="group relative rounded-2xl overflow-hidden bg-white border border-slate-200 hover:border-orange-300 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300">
                <div className="relative h-48 overflow-hidden">
                  <img src={s.image} alt={t(`services.items.${s.id}.title`)} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <span className="absolute top-4 left-4 bg-orange-500 text-white text-[11px] font-semibold uppercase tracking-wider px-3 py-1 rounded-full">
                    {t(`services.items.${s.id}.tag`)}
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-900">{t(`services.items.${s.id}.title`)}</h3>
                  <p className="mt-1 text-sm text-slate-500">{t(`services.items.${s.id}.subtitle`)}</p>

                  <div className="mt-4">
                    <div className="text-xs font-semibold text-slate-700">{t('services.childServices')}</div>
                    <ul className="mt-2 grid grid-cols-1 gap-1.5">
                      {(items || []).map((it) => (
                        <li key={it} className="flex items-center gap-2 text-sm text-slate-700">
                          <Check className="h-4 w-4 text-emerald-500" /> {it}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mt-6 flex flex-wrap gap-2">
                    <Link to={`/services/${s.slug}`} data-testid={`service-details-${s.slug}`}>
                      <Button className="bg-slate-900 hover:bg-slate-800 text-white h-10">
                        {t('common.viewDetails')} <ArrowRight className="h-4 w-4 ml-1" />
                      </Button>
                    </Link>
                    <Button onClick={onBookCall} variant="outline" className="h-10 border-slate-300 text-slate-800 hover:bg-slate-100">
                      {t('common.bookAppointment')}
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
